import PrivacyAgreementFormContainer from './privacy_agreement_form_container';

const PrivacyAgreementForm = PrivacyAgreementFormContainer;
export default PrivacyAgreementForm;
